import { apiDelete, apiGet, apiPost, apiPut, queryString, type ApiResult } from "./client";
import type { AffectedLessons, Classroom, DayGrid, WeeklyUnavailable } from "./types";
import type { NewPeriod } from "./teachers";

export interface ClassroomFields {
  centerId: string;
  name: string;
  capacity: number | null;
  note: string;
  weeklyUnavailable: WeeklyUnavailable[];
}

export async function fetchClassrooms(includeArchived: boolean): Promise<ApiResult<Classroom[]>> {
  return apiGet<Classroom[]>("/classrooms" + queryString({ includeArchived }));
}

export async function fetchClassroom(id: string): Promise<ApiResult<Classroom>> {
  return apiGet<Classroom>(`/classrooms/${id}`);
}

export async function createClassroom(fields: ClassroomFields): Promise<ApiResult<Classroom>> {
  return apiPost<Classroom>("/classrooms", fields);
}

export async function updateClassroom(id: string, fields: ClassroomFields,
  version: number): Promise<ApiResult<Classroom>> {
  return apiPut<Classroom>(`/classrooms/${id}`, { ...fields, version });
}

export async function setClassroomArchived(id: string, archived: boolean,
  version: number): Promise<ApiResult<Classroom>> {
  const action: string = archived ? "archive" : "unarchive";
  return apiPost<Classroom>(`/classrooms/${id}/${action}`, { version });
}

export async function deleteClassroom(id: string): Promise<ApiResult<null>> {
  return apiDelete<null>(`/classrooms/${id}`);
}

export async function addClassroomPeriod(id: string, period: NewPeriod): Promise<ApiResult<AffectedLessons>> {
  return apiPost<AffectedLessons>(`/classrooms/${id}/unavailability`, period);
}

export async function removeClassroomPeriod(id: string, periodId: string): Promise<ApiResult<null>> {
  return apiDelete<null>(`/classrooms/${id}/unavailability/${periodId}`);
}

export async function fetchClassroomDay(id: string, date: string): Promise<ApiResult<DayGrid>> {
  return apiGet<DayGrid>(`/classrooms/${id}/day` + queryString({ date }));
}
